/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_DeleteInputs */

const en_us2_body_assessment_delete = /** @type {(inputs: Body_Assessment_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete assessment`)
};

const pt_br2_body_assessment_delete = /** @type {(inputs: Body_Assessment_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apagar avaliação`)
};

const es_419_body_assessment_delete = /** @type {(inputs: Body_Assessment_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar evaluación`)
};

const pt_pt2_body_assessment_delete = /** @type {(inputs: Body_Assessment_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apagar avaliação`)
};

const fr_fr2_body_assessment_delete = /** @type {(inputs: Body_Assessment_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer l'évaluation`)
};

const de_de2_body_assessment_delete = /** @type {(inputs: Body_Assessment_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Messung löschen`)
};

const it_it2_body_assessment_delete = /** @type {(inputs: Body_Assessment_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elimina valutazione`)
};

/**
* | output |
* | --- |
* | "Delete assessment" |
*
* @param {Body_Assessment_DeleteInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_delete = /** @type {((inputs?: Body_Assessment_DeleteInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_DeleteInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_delete(inputs)
	if (locale === "es-419") return es_419_body_assessment_delete(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_delete(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_delete(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_delete(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_delete(inputs)
	return en_us2_body_assessment_delete(inputs)
});
export { body_assessment_delete as "body-assessment.delete" }